import { useEffect, useState } from "react";
import LoadingPageSm from "../../CommonComponent/LoadingPageSm";
import { Button, Modal } from "react-bootstrap";
import InputLebelComponent from "../../InputLebel/InputLebelComponent";
import { BsPlus, BsTrash } from "react-icons/bs";
import Swal from "sweetalert2";
import swalWithBootstrapButtons from "sweetalert2-react-content";
import { toast } from "react-toastify";
import removeLanguageToUser from "../../../apis/removeLanguageToUser";
import getLanguagesBySearchText from "../../../apis/getLanguagesBySearchText";
import addLanguageToUser from "../../../apis/addLanguageToUser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";

const Language = ({ languageDetails, resourceSlug, profileName }) => {
  const MySwal = swalWithBootstrapButtons(Swal);
  const [isLoading, setIsLoading] = useState(true);
  const [language, setLanguage] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [languageSearchText, setLanguageSearchText] = useState("");
  const [searchedLanguages, setSearchedLanguages] = useState([]);
  const [isLoadingLanguageSearch, setIsLoadingLanguageSearch] = useState(false);
  const [filterTextStatus, setFilterTextStatus] = useState(
    "Your search languages will be displayed here"
  );
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    setIsLoading(false);
    setLanguage(languageDetails || []);
  }, [languageDetails]);

  const handleCloseEditModal = () => setShowEditModal(false);
  const handleShowEditModal = () => setShowEditModal(true);
  const handleTextChange = (e) => setLanguageSearchText(e.target.value);

  useEffect(() => {
    if (languageSearchText.trim().length > 1) {
      const delay = setTimeout(() => getLanguageWithSearchText(), 500);
      return () => clearTimeout(delay);
    } else {
      setSearchedLanguages([]);
      setFilterTextStatus("Your search languages will be displayed here");
    }
  }, [languageSearchText]);

  const getLanguageWithSearchText = () => {
    setIsLoadingLanguageSearch(true);
    getLanguagesBySearchText(languageSearchText, resourceSlug)
      .then(({ data }) => {
        if (data?.status === 1) {
          setSearchedLanguages(data.languages);
        } else {
          setSearchedLanguages([]);
          setFilterTextStatus(data.message || "No results found");
        }
      })
      .catch(() => {
        setFilterTextStatus("Server error. Try again later.");
      })
      .finally(() => setIsLoadingLanguageSearch(false));
  };

  const addLanguage = (id, item) => {
    setIsProcessing(true);
    addLanguageToUser(resourceSlug, id)
      .then(({ data }) => {
        if (data?.status) {
          setSearchedLanguages((current) =>
            current.filter((l) => l.language_id !== id)
          );
          setLanguageSearchText("");
          setLanguage((prev) => [...prev, item]);
          toast.success(data.message);
        } else {
          toast.warning(data.message);
        }
      })
      .catch(console.error)
      .finally(() => setIsProcessing(false));
  };

  const removeLanguage = (id, name) => {
    MySwal.fire({
      title: "Are you sure?",
      text: `that you want to remove ${name}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, remove!",
      cancelButtonText: "Cancel",
      reverseButtons: true,
      confirmButtonColor: "var(--danger)",
      cancelButtonColor: "var(--black)",
    }).then((result) => {
      if (result.isConfirmed) {
        setIsProcessing(true);
        removeLanguageToUser(resourceSlug, id)
          .then(({ data }) => {
            if (data?.status) {
              setLanguage((prev) => prev.filter((l) => l.language_id !== id));
              toast.success(data.message);
            } else {
              toast.warning(data.message);
            }
          })
          .catch(console.error)
          .finally(() => setIsProcessing(false));
      }
    });
  };

  const displayRawLanguages = () => (
    <>
      <p className="fw-bold-custom">Current Languages</p>
      <div className="d-flex flex-wrap">
        {language.length > 0 ? (
          language.map((item) => (
            <button
              className="btn my-1 me-1 mb-2 d-flex btn-dark"
              key={item.language_id}
              disabled={isProcessing}
              onClick={() => removeLanguage(item.language_id, item.value)}
            >
              <span>{item.value}</span>
              <div className="ms-2 pe-none cursor-pointer">
                <BsTrash className="text-light" />
              </div>
            </button>
          ))
        ) : (
          <span className="text-muted">No languages found.</span>
        )}
      </div>
    </>
  );

  const displaySearchLanguages = () => (
    <div className="form-input-holder">
      <InputLebelComponent title="Search Languages" />
      <input
        type="text"
        className="form-control"
        placeholder="Search language to add"
        value={languageSearchText}
        onChange={handleTextChange}
        autoComplete="off"
      />
      <div className="border-dark p-2 rounded my-2 bg-light">
        {isLoadingLanguageSearch ? (
          <LoadingPageSm />
        ) : searchedLanguages.length > 0 ? (
          <div className="d-flex flex-wrap">
            {searchedLanguages.map((item) => (
              <button
                className="btn my-1 me-1 mb-2 d-flex btn-success"
                key={item.language_id}
                disabled={isProcessing}
                onClick={() => addLanguage(item.language_id, item)}
              >
                <span>{item.value}</span>
                <div className="ms-2 pe-none cursor-pointer">
                  <BsPlus className="text-light" />
                </div>
              </button>
            ))}
          </div>
        ) : (
          <span>{filterTextStatus}</span>
        )}
      </div>
    </div>
  );

  return (
    <>
      <div className="d-flex align-items-center justify-content-between mb-2">
        <h6 className="mb-0">Languages</h6>
        <FontAwesomeIcon
          icon={faEdit}
          className="text-primary cursor-pointer"
          title="Edit Languages"
          role="button"
          onClick={handleShowEditModal}
        />
      </div>

      {isLoading ? (
        <LoadingPageSm />
      ) : language.length > 0 ? (
        <div className="d-flex flex-wrap">
          {language.map((item) => (
            <span key={item.language_id} className="badge-gray  text-sm">
              {item.value.replace(/[^a-zA-Z0-9 ]/g, "")}
            </span>
          ))}
        </div>
      ) : (
        <small className="text-muted">Nothing to display here!</small>
      )}

      <Modal
        show={showEditModal}
        onHide={handleCloseEditModal}
        centered
        scrollable
        backdrop="static"
      >
        <Modal.Header>
          <span className="fw-bold-custom">
            Edit Languages for {profileName}
          </span>
        </Modal.Header>
        <Modal.Body>
          {displaySearchLanguages()}
          {displayRawLanguages()}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" size="sm" onClick={handleCloseEditModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Language;
